import { html, nothing } from 'lit';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { map } from 'lit/directives/map.js';
import { when } from 'lit/directives/when.js';
import { BoilerplateModal } from './boilerplate_modal';

class ModalBackInStock extends BoilerplateModal {
  static get properties() {
    return {
      product: { type: Object, attribute: true },
      customer: { type: Object },
    };
  }

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener('back-in-stock-form:submit', this.formSubmitted.bind(this));
    document.addEventListener('modal-back-in-stock:update-product', this.updateProduct.bind(this));
  }

  updateProduct(e) {
    if (!this.open || !e.detail?.product) {
      return;
    }

    this.detail = { ...this.detail, ...e.detail };
    this.product = e.detail.product;
    this.requestUpdate();
  }

  formSubmitted() {
    this.timeout = setTimeout(() => {
      this.toggleModal();
    }, 3000);
  }

  toggleModal(e) {
    if (this.open) {
      const resetForm = new CustomEvent('back-in-stock-form:reset');
      document.dispatchEvent(resetForm);
    }
    super.toggleModal(e);
    if (!this.open && this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  renderDisclaimer() {
    return html`
      ${ unsafeHTML(window.theme.strings.back_in_stock.disclaimer_html) }
    `;
  }

  renderBody() {

    if (this.detail?.product) {
      this.product = this.detail?.product;
    }
  
    if (!this.product) {
      console.error('No product found for back in stock modal');
      return nothing;
    }

    return html`
      <div class="subtitle">${ unsafeHTML(window.theme.strings.back_in_stock.description_html) }</div>
      <div class="bis_product_name">${ this.product.title }</div>
      ${ this.open
        ? this.product.variants?.length || this.detail?.variant_id
          ? html`
            <back-in-stock-form
              .product=${ this.product }
              variant-id=${ ifDefined(this.detail?.variant_id) }
              .customer=${ this.customer }
            >
            </back-in-stock-form>
          `
          : html`<bouncing-ellipsis></bouncing-ellipsis>`
        : nothing
      }
      ${ this.renderDisclaimer() }
    `;
  }
}

window.customElements.get('modal-back-in-stock') || window.customElements.define('modal-back-in-stock', ModalBackInStock);